import React from 'react';

const Dot = (props: any) => {
    const { cx, cy, r, stroke, strokeWidth, index, lastIdx } = props;
    const shouldRender = index === lastIdx;
    return shouldRender ? (
        <circle cx={cx} cy={cy} r={r} stroke={stroke} fill={stroke} strokeWidth={strokeWidth} />
    ) : null;
};

export default Dot;
